import { AnchorHTMLAttributes } from 'react';
import { Box } from '@mantine/core';
import { pickTextColorForBackground } from '../../utils/color';

interface SkipLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  label?: string;
  href?: string;
}

export function SkipLink({ label = 'Skip to content', href = '#main', ...rest }: SkipLinkProps) {
  const backgroundColor = 'var(--mantine-color-blue-6)';
  const textColor = pickTextColorForBackground('#228be6'); // blue.6 default value

  return (
    <Box
      component="a"
      href={href}
      {...rest}
      style={{
        position: 'absolute',
        top: -40,
        left: 16,
        padding: '8px 12px',
        background: backgroundColor,
        color: textColor,
        borderRadius: 8,
        zIndex: 1000,
        transform: 'translateY(-100%)',
        transition: 'transform 120ms ease',
      }}
      onFocus={(event) => {
        event.currentTarget.style.transform = 'translateY(0)';
      }}
      onBlur={(event) => {
        event.currentTarget.style.transform = 'translateY(-100%)';
      }}
    >
      {label}
    </Box>
  );
}
